import { Controller } from "@hotwired/stimulus"
import { showProcessingOverlay, hideProcessingOverlay } from "../processing_overlay"

const OVERLAY_ID = "stage-closing-overlay"

// Encerrar uma etapa salva o que está na tela, grava assinatura, dispara
// contrato e sincronismo — segundos em que a página fica parada. A barrinha do
// Turbo no topo é discreta demais para isso: quem não vê resposta clica de
// novo. Aqui a tela inteira diz que está encerrando.
export default class extends Controller {
  connect() {
    this.onSubmitEnd = (event) => {
      if (!event.detail?.success) hideProcessingOverlay(OVERLAY_ID)
    }
    this.element.addEventListener("turbo:submit-end", this.onSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.onSubmitEnd)
    hideProcessingOverlay(OVERLAY_ID)
  }

  show(event) {
    // Campo obrigatório em branco barra o envio antes de sair da tela: cobrir a
    // página aí esconderia justamente o aviso do navegador.
    if (event?.target?.checkValidity && !event.target.checkValidity()) return

    showProcessingOverlay({
      id: OVERLAY_ID,
      title: "Encerrando a etapa",
      subtitle: "Guardando o que você preencheu. Não feche esta janela."
    })
  }
}
